import React from 'react';
import { Modal, notification } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Group, openNotificationWithIcon } from '@mss/mss-component-library';
import Api from '../../../services/Api';
import { QueryClient } from '@tanstack/react-query';
import type { TFunction } from 'i18next';

const DeleteGroupModal = (
  group: Group,
  t: TFunction,
  queryClient: QueryClient,
  onOk?: () => void
) =>
  Modal.confirm({
    title: t('Are you sure you want to delete?'),
    icon: (
      <span className="anticon">
        <FontAwesomeIcon
          icon={faExclamationTriangle}
          color="#fd9644"
          size="sm"
        />
      </span>
    ),
    content: t(
      `You're about to delete the group. This means all inherited permission for the coupled users.`
    ),
    onOk: async () => {
      const remove = await Api.group.remove(group.id);
      if (remove.status === 403) {
        openNotificationWithIcon(
          notification.error,
          t(`Failed to delete group`),
          t(
            "Cannot delete group. It seems it's still linked to some assets. Please assign a different custodian to the assets."
          )
        );
      }
      if (remove.status === 204) {
        await queryClient.invalidateQueries({
          queryKey: ['groups'],
        });

        openNotificationWithIcon(
          notification.success,
          t('Group was deleted'),
          t('The group has been deleted successfully.')
        );
      }
      if (onOk) onOk();
    },
  });

export default DeleteGroupModal;
